var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M19.4951 8.20043L10.3323 1.38477L1.16944 8.20043C1.07413 8.28437 0.996763 8.38601 0.941781 8.49945C0.8868 8.6129 0.855291 8.7359 0.849121 8.86134V19.2046C0.849121 19.4237 0.937944 19.6339 1.09603 19.7888C1.25411 19.9437 1.4685 20.0308 1.69207 20.0308H7.1881V15.6357C7.1881 14.814 7.52112 14.0261 8.11393 13.4451C8.70674 12.8641 9.51078 12.5377 10.3491 12.5377C11.1875 12.5377 11.9915 12.8641 12.5843 13.4451C13.1771 14.0261 13.5102 14.814 13.5102 15.6357V19.9729H19.0062C19.2297 19.9729 19.4442 19.8859 19.6023 19.731C19.7604 19.576 19.8491 19.3659 19.8491 19.1468V8.82003C19.8173 8.57641 19.6904 8.35435 19.4951 8.20043V8.20043Z",
          stroke: "white",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }